<template>
  <RouterLink
    class="item"
    :class="getRootClasses"
    :to="to"
  >
    <div class="item__icon-wrapper">
      <BaseIcon
        :icon="icon"
        class="item__icon"
      />

      <div v-if="postscript" class="item__postscript">
        {{ postscript }}
      </div>
    </div>
    <span class="item__text">{{ text }}</span>
  </RouterLink>
</template>

<script>
import BaseIcon from '@/components/Base/BaseIcon'

export default {
  name: 'AppSidebarButton',
  components: {
    BaseIcon
  },
  props: {
    icon: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    to: {
      type: String,
      default: '#'
    },
    active: {
      type: Boolean,
      default: false
    },
    postscript: {
      type: [String, Number],
      default: null
    }
  },
  computed: {
    getRootClasses () {
      return {
        item_active: this.active
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$brand-color:                 #FF7A00 !default;

.item {
  display: flex;
  align-items: center;
  color: #E0E0EB;
  text-decoration: none;
  transition: .2s;

  &:hover,
  &_active {
    color: $brand-color;

    .item__postscript { color: #fff }
  }

  &__icon-wrapper {
    width: 20px;
    height: 20px;
    position: relative;
  }

  &__postscript {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    background: $brand-color;
    height: 18px;
    width: 18px;
    font-size: 12px;
    border-radius: 1000px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
  }

  &__text {
    margin-left: 20px;
    font-size: 18px;
    line-height: 22px;
  }
}
</style>
